import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import IconArticle from "./article.svg";
import IconInfographic from "./infographic.svg";
import IconOpinion from "./opinion.svg";
import IconPodcast from "./podcast.svg";
import IconVideo from "./video.svg";

export const Container = styled.div`
  display: flex;
`;

export const Icon = styled.div`
  margin-inline-end: 8px;
  svg {
    inline-size: 17px;
    block-size: 17px;
  }
`;

export const StyledIconArticle = styled(IconArticle)``;
export const StyledIconInfographic = styled(IconInfographic)``;
export const StyledIconOpinion = styled(IconOpinion)``;
export const StyledIconPodcast = styled(IconPodcast)``;
export const StyledIconVideo = styled(IconVideo)``;

export const SeriesType = styled.div`
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 19px;
  text-transform: capitalize;
`;
